import { render, staticRenderFns } from "./MultipleField.vue?vue&type=template&id=1ba94fc5&lang=pug"
import script from "./MultipleField.vue?vue&type=script&lang=js"
export * from "./MultipleField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports